module.exports = __webpack_public_path__ + "img/email.3af72983.svg";